{
    "general": {
        "alumnos": "Alumnos",
        "alumno": "Alumno",
        "grupo": "Grupo",
        "grupos": "Grupos",
        "escuela": "Escuela",
        "error": "Ocurrió un error",
        "acepta": "Aceptar",
        "cancela": "Cancelar",
        "comentario": "Comentario",
        "sendfile": "Enviar archivo",
        "option_required": "Seleccione una opción",
        "optional": "Opcional",
        "user_reintent": "Intentelo de nuevo",
        "retry": "Reintentar",
        "nofound": "No encontrado",
        "write_descript": "Escribe una descripción",
        "day": "Día",
        "today": "Hoy",
        "min": "Min",
        "max": "Max",
        "config": "Configuración",
        "loading...": "Cargando...",
        "maxfilesonceimport": "No se permite seleccionar más de _ archivo/s por importación",
        "filenosoported": "Archivo _ no soportado",
        "error_file_process": "Error al procesar el archivo",
        "error_image_process": "Error al procesar la imagen",
        "no_available": "No disponible",
        "no_apply": "No aplica",
        "no_config": "Sin configuración",
        "non_available_view": "Vista no disponible",
        "unknown": "Desconocido",
        "sync": "Sincronizar",
        "syncing": "Sincronizando...",
        "sync_success": "Sincronización exitosa",
        "sync_fail": "Error al sincronizar",
        "close": "Cerrar",
        "close_fail": "Error al cerrar",
        "sort": "Ordenar"
    },
    "sesion": {
        "logout": "Cerrar sesión",
        "logout_fail": "Error al cerrar sesión",
        "title_confirm": "¡Cerrar sesión!",
        "description": "¿Desea cerrar la sesión?"
    },
    "ui.c_estado_proximidad": {
        "1": "En camino",
        "2": "En zona escolar",
        "3": "Cerca de la entrada",
        "4": "Abandono de zona",
        "5": "Cancelado",
        "6": "Completado"
    },
    "ui.time": {
        "now": "Justo ahora",
        "seconds_ago": "Hace _ segundos",
        "minutes_ago": "Hace _ minutos",
        "hours_ago": "Hace _ horas",
        "days_ago": "Hace _ días",
        "weeks_ago": "Hace _ semanas",
        "months_ago": "Hace _ meses",
        "years_ago": "Hace _ años"
    },
    "ui.proximidad": {
        "title": "Fila de entrega",
        "subtitle": "Alumnos ordenados por proximidad de su tutor",
        "tutores_no_en_camino": "No hay tutores en camino",
        "seleccionar_grupo": "Selecciona un grupo",
        "radar_desactivado": "Radar de proximidad desactivado para la escuela _",
        "grupo": "Grupo",
        "grupos_seleccionados": "_ grupos seleccionados",
        "seleccionar_todo": "Seleccionar todo",
        "a_distancia": "A _"
    },
    "login": {
        "login": "Iniciar sesión",
        "user": "Usuario",
        "pass": "Contraseña",
        "recoverpass": "Recuperar contraseña",
        "user_required": "Campo usuario requerido"
    },
    "modulo": {
        "E/S": "Entrada y salida",
        "salon": "Salón",
        "extemp": "Registros extemporáneos",
        "chat": "Chat",
        "agenda": "Agenda",
        "report": "Reporte",
        "qr": "QR",
        "home": "Home"
    },
    "E/S": {
        "entrada": "Entrada",
        "salida": "Salida",
        "noopera": "No habilitado para operar",
        "sinhorarioext": "Sin horario extendido",
        "alumno_fuera": "El alumno _ se encuentra fuera del horario para este grupo",
        "entraa_grupo": "Entrada a grupo",
        "entraa_escuela": "Entrada a escuela",
        "alumno_noval": "Alumn@ no activo o ya está en grupo",
        "success_title": "¡Listo!",
        "alumno_llego_esc": "_ llegó a la escuela",
        "alumno_salio_esc": "_ salió de la escuela",
        "alumno_salio_g": "_ salió del grupo",
        "otrogrupo_title": "Entrada a otro grupo",
        "selecciona": "Seleccionar algún alumno de la lista",
        "envia_a": "Enviar _ a:",
        "no_child_enter": "No hay alumnos para dar entrada",
        "no_child_exit": "No hay alumnos para dar salida",
        "confirm_salida": "¿Estás seguro de dar salida a _?",
        "confirm_enviar_a": "¿Estás seguro de enviar a _ al grupo _?"
    },
    "extemporal": {
        "title": "Registro extemporáneo",
        "child_extemp": "Alumnos extemporáneos",
        "no_childs": "No hay alumnos extemporáneos"
    },
    "event": {
        "evrecord": "Registrar evento",
        "record_success": "Se ha registrado correctamente el _"
    },
    "snooze": {
        "title": "Evento siesta",
        "inicio": "Inicio",
        "fin": "Fin",
        "sleep_now": "Dormir ahora",
        "wake_up": "Despertar",
        "inprogress": "En curso",
        "record_snooze": "Registrar siesta",
        "record_success": "Se ha registrado una nueva siesta",
        "deshacer_select": "Registrar siesta seleccionado, presione nuevamente para deshacer la selección",
        "iniciofin_required": "Captura la hora de inicio y la hora final",
        "error_fininicio": "La hora fin debe ser menor a la hora actual",
        "error_iniciofin": "La hora inicio debe ser menor a hora fin",
        "error_dormido": "Alguno de los alumnos debe estar despierto",
        "require_samestatus": "Solo se pueden seleccionar alumn@s en el mismo estado, despiert@s o dormid@s"
    },
    "food": {
        "title": "Evento comida",
        "bib/pap": "Biberón/papilla",
        "porcion": "Porción",
        "tipo_pap": "Tipo papilla",
        "porcion_required": "Seleccionar porción",
        "tipo_required": "Seleccionar tipo",
        "school_food": "Comida de escuela",
        "cal_food": "Comida de calendario",
        "food_house": "Comida de casa",
        "cake": "Pastel",
        "no_alumnorecsel": "No registrada en alumn@s seleccionados",
        "hour_required": "Selecciona un horario",
        "hour_required_to": "Selecciona un horario para _",
        "hour_menor": "La hora debe ser menor a la hora actual",
        "tcomida_required": "Selecciona un tipo de comida",
        "tbib/pall_required": "Seleccione algún tipo de biberón/papilla",
        "confirm_reg": "¿Está seguro de registrar _?",
        "childs_novalid": "No existen alumnos válidos para éste alimento"
    },
    "hygiene": {
        "title": "Evento higiene",
        "pipi": "Pipí",
        "popo": "Popó",
        "dients": "Dientes",
        "accident": "Accidente",
        "intent": "Intento",
        "hour_required": "Seleccione un horario para _",
        "hour_menor": "La hora debe ser menor a la hora actual en: ",
        "tipo_required": "Selecciona un tipo de higiene"
    },
    "activity": {
        "title": "Evento actividad",
        "act": "Actividad",
        "act_required": "Captura nombre de la actividad"
    },
    "milestone": {
        "title": "Evento logro",
        "registrado": "Registrado",
        "iniciado": "Iniciado",
        "avanzado": "Avanzado",
        "terminado": "Terminado",
        "aunsinlogros": "Parece que aún no hay logros registrados",
        "logro_required": "Seleccionar al menos un logro",
        "nuevameta": "Nueva meta iniciada",
        "avance_s": "Avance significativo",
        "alcanzado": "Meta alcanzada",
        "nomultiplechild": "Selecciona solo un alumno para registrar logros"
    },
    "evaluacion": {
        "title": "Evento evaluación",
        "evals_required": "No hay evaluaciones asignadas",
        "pendientes_empty": "Sin evaluaciones pendientes",
        "materia": "Materia",
        "fecha_inicio": "Fecha inicio",
        "fecha_eval": "Fecha evaluación",
        "criterio": "Criterio",
        "observacion": "Observación",
        "eval": "Evaluación",
        "invalid_data": "Datos no válidos, revisa la información",
        "nomultiplechild": "Selecciona solo un alumno para registrar calificaciones",
        "no_crit": "Sin criterios",
        "no_asistencia_valida": "Durante el periodo de evaluación el alumno no tuvo asistencias",
        "search_placeholder": "Buscar materia o criterio",
        "enable_only_period": "Mostrar solo fechas del periodo",
        "no_found_dates": "No se encontraron fechas de asistencia",
        "tag_solo_fechas_asistencia": "Solo puedes seleccionar fechas donde el alumno tuvo asistencias"
    },
    "photo": {
        "title": "Evento foto",
        "alumno_required": "Seleccionar alumn@s",
        "loadphoto_required": "Agregue imagenes a subir",
        "selectphoto_required": "Seleccione las imagenes a subir"
    },
    "comment": {
        "title": "Evento comentario",
        "tnormal": "Normal",
        "timportant": "Importante",
        "tmedicina": "Medicina",
        "alumnos_required": "Seleccionar alumn@s",
        "options_required": "Seleccione alguna de las opciones",
        "comments_required": "Llene la caja de comentarios"
    },
    "humor": {
        "title": "Evento humor",
        "humor_required": "Seleccione algún estado de animo"
    },
    "report": {
        "salon": "Salón",
        "no_childs": "No hay alumnos en el grupo"
    },
    "reportchild": {
        "title": "Reporte",
        "group": "Grupo",
        "no_events": "Sin eventos registrados",
        "load_error": "Error al cargar la información"
    },
    "agenda": {
        "cumple": "Cumplirá _ años",
        "activity": "Actividad",
        "add_act": "Agregar actividad",
        "upd_act": "Actualizar actividad",
        "del_act": "Eliminar actividad",
        "fecha_invalid": "Selecciona una fecha válida",
        "fecha_nomenor": "La fecha debe ser mayor o igual a la actual",
        "confirm_delete": "¿Desea eliminar esta tarea?",
        "weather_not_available": "Reporte de clima no disponible",
        "agenda_without_records": "Sin actividades agendadas"
    },
    "classroom": {
        "alumno_ent": "Entrada alumno",
        "alumnos_sin_g": "Se encontraron alumnos sin grupo activo",
        "reg_ev": "Registrar evento",
        "entrada_si": "Sí, dar entrada",
        "entrada_no": "No, no dar entrada",
        "confirm_entrada_si": "¿Estás seguro de dar entrada a _?",
        "confirm_entrada_no": "¿Estás seguro de no dar entrada a _?",
        "entraa_grupo_title": "Entrada a grupo",
        "entraa_grupo": "¡Entrada a grupo: _!",
        "alumno_llego_esc": "_ llegó a la escuela",
        "alumno_llego_g": "_ llegó al grupo",
        "no_childs": "No hay alumnos en el salón",
        "entrada_classroom": "¿Dar entrada al salón?"
    },
    "chat": {
        "escribe": "Escriba un mensaje aquí",
        "confirm_download": "¿Desea descargar el archivo?",
        "send_c": "Enviar chat",
        "fail_sendg_msg": "El mensaje no se envio a todos los alumnos del grupo",
        "focuschat": "Selecciona un chat en la lista de alumnos",
        "": ""
    },
    "home": {
        "g_prim": "Grupos principales",
        "g_sec": "Grupos secundarios",
        "without_groups": "Sin grupos asignados",
        "groups_no_found": "Sin grupos encontrados",
        "filter_required": "Selecciona un filtro"
    },
    "perfil": {
        "upt_title": "Actualizar perfil",
        "groups": "Grupos",
        "brothers": "Hermanos"
    },
    "qr": {},
    "time": {
        "anio": "Año",
        "anios": "Años",
        "mes": "Mes",
        "mess": "Meses",
        "dia": "Día",
        "dias": "Días",
        "hr": "Hora",
        "hrs": "Horas",
        "min": "Minuto",
        "mins": "Minutos",
        "sec": "Segundo",
        "secs": "Segundos",
        "ms": "Milisegundo",
        "mss": "Milisegundos"
    },
    "validity": {
        "input_invalid": "Entrada no válida",
        "required_def": "Campo obligatorio",
        "required_dev": "_ obligatorio",
        "min_length": "Mínimo _ caracteres",
        "max_length": "Máximo _ caracteres",
        "range_overflow": "Valor máximo _",
        "range_underflow": "Valor mínimo _"
    },
    "c_evt": {
        "1": "Siesta",
        "2": "Comida",
        "3": "Higiene",
        "4": "Actividad",
        "5": "Logros",
        "6": "Fotos",
        "7": "Comentarios",
        "8": "Humor",
        "9": "Calificación"
    },
    "c_humor": {
        "1": "Feliz",
        "2": "Serio",
        "3": "Triste",
        "4": "Travieso",
        "5": "Enojado",
        "6": "Somnoliento",
        "7": "Enfermo",
        "8": "Lloroso"
    }
}